import React, { useEffect, useState } from 'react';
import { Table, Tag, Spin, Collapse, Card, Row, Col, Statistic, Modal, message, Button } from 'antd';
import moment from 'moment';
import ENVIRONMENT from '../../../../environments';
import CustomerMainLayout from '../CustomerMainLayout';
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
const CUSTOMER_USERNAME = localStorage.getItem('username');


const ShopifyJobStatus = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    // Bulk upload states
    const [bulkModalVisible, setBulkModalVisible] = useState(false);
    const [bulkUploading, setBulkUploading] = useState(false);
    const [bulkFile, setBulkFile] = useState(null);

    useEffect(() => {
        fetchJobItems();
    }, []);

    const fetchJobItems = async () => {
        try {
            const res = await fetch(ENVIRONMENT.SHOPIFY_GET_JOB_ITEMS, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username: localStorage.getItem('username')
                })
            });
            if (res.ok) {
                const data = await res.json();
                if (data.statusCode === 200) {
                    setData(data.body.items);
                }
            }
        } catch (err) {
            console.error('Error fetching job items:', err);
        }
        setLoading(false);
    };

    const columns = [
        {
            title: <span className="manrope f-14 black-14 w-600">ID</span>,
            dataIndex: 'id',
            key: 'id',
            width: 70,
            render: (id) => <span className="manrope f-14">{id || '-'}</span>,
        },
        {
            title: <span className="manrope f-14 black-14 w-600">Product ID</span>,
            dataIndex: 'product_id',
            key: 'product_id',
            width: 100,
            render: (product_id) => <span className="manrope f-14">{product_id || '-'}</span>,
        },
        {
            title: <span className="manrope f-14 black-14 w-600">Status</span>,
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (status) => (
                <Tag className="manrope f-14" color={
                    status === 'PENDING' ? 'blue' :
                        status === 'SUCCESS' ? 'green' :
                            status === 'FAILED' ? 'red' : 'default'
                }>
                    {status}
                </Tag>
            ),
        },
        {
            title: <span className="manrope f-14 black-14 w-600">Title</span>,
            dataIndex: 'title',
            key: 'title',
            render: (title) => <span className="manrope f-14">{title || '-'}</span>,
        },
        {
            title: <span className="manrope f-14 black-14 w-600">Handle</span>,
            dataIndex: 'handle',
            key: 'handle',
            render: (handle) => <span className="manrope f-14">{handle || '-'}</span>,
        },
        {
            title: <span className="manrope f-14 black-14 w-600">Attempts</span>,
            dataIndex: 'attempts',
            key: 'attempts',
            width: 90,
            align: 'center',
            render: (attempts) => <span className="manrope f-14">{attempts || '-'}</span>,
        },
        {
            title: <span className="manrope f-14 black-14 w-600">Created At</span>,
            dataIndex: 'created_at',
            key: 'created_at',
            width: 150,
            render: (date) => <span className="manrope f-14">{moment(date).format('YYYY-MM-DD HH:mm:ss')}</span>,
        },
        {
            title: <span className="manrope f-14 black-14 w-600">Last Error</span>,
            dataIndex: 'last_error',
            key: 'last_error',
            render: (error) => <span className="manrope f-14">{error || '-'}</span>,
        },
        {
            title: <span className="manrope f-14 black-14 w-600">Shop</span>,
            dataIndex: 'shop',
            key: 'shop',
            render: (shop) => <span className="manrope f-14">{shop || '-'}</span>,
        },
        {
            title: <span className="manrope f-14 black-14">Job Status</span>,
            dataIndex: 'job_status',
            key: 'job_status',
            width: 100,
            render: (status) => (
                <Tag className="manrope f-14" color={
                    status === 'PENDING' ? 'blue' :
                        status === 'SUCCESS' ? 'green' :
                            status === 'FAILED' ? 'red' : 'default'
                }>
                    {status}
                </Tag>
            ),
        },
    ];

    const groupedData = data.reduce((acc, item) => {
        if (!acc[item.job_id]) {
            acc[item.job_id] = {
                items: [],
                status: {
                    PENDING: 0,
                    SUCCESS: 0,
                    FAILED: 0
                },
                shop: item.shop,
                created_at: item.created_at
            };
        }
        acc[item.job_id].items.push(item);
        acc[item.job_id].status[item.status]++;
        return acc;
    }, {});

    const { Panel } = Collapse;

    return (
        <CustomerMainLayout>
            <div style={{ padding: '24px' }}>
                <Row className='mb-20'>
                    <Col span={24} className='justify-space-between'>
                        <h2 className="manrope f-24 w-700 mb-0">Shopify Job Statuses</h2>
                        <Button className='new-product-btn black f-14' onClick={() => setBulkModalVisible(true)}>
                            <PlusOutlined />&nbsp;Bulk Upload
                        </Button>
                    </Col>
                </Row>
                {loading ? (
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        <Spin size="large" />
                    </div>
                ) : (
                    <Collapse defaultActiveKey={[Object.keys(groupedData)[0]]}>
                        {Object.entries(groupedData).map(([jobId, jobData]) => (
                            <Panel className='shopify-collapse-custom-panel'
                                key={jobId}
                                header={
                                    <Row gutter={[16, 8]} align="middle" style={{ width: '100%' }}>
                                        <Col xs={24} sm={12} md={8} lg={6}>
                                            <Statistic
                                                title={<span className="manrope f-14 black-14 w-600">Job ID</span>}
                                                value={jobId}
                                                valueStyle={{ color: '#141414', fontSize: '14px', fontFamily: 'Manrope' }}
                                            />
                                        </Col>
                                        <Col xs={24} sm={12} md={8} lg={6}>
                                            <Statistic
                                                title={<span className="manrope f-14 black-14 w-600">Created At</span>}
                                                value={moment(jobData.created_at).format('YYYY-MM-DD HH:mm:ss')}
                                                valueStyle={{ color: '#141414', fontSize: '14px', fontFamily: 'Manrope' }}
                                            />
                                        </Col>
                                        <Col xs={24} sm={12} md={8} lg={6}>
                                            <Statistic
                                                title={<span className="manrope f-14 black-14 w-600">Shop</span>}
                                                value={jobData.shop}
                                                valueStyle={{ color: '#141414', fontSize: '14px', fontFamily: 'Manrope' }}
                                            />
                                        </Col>
                                        <Col xs={24} sm={12} md={8} lg={6}>
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <Statistic
                                                        title={<span className="manrope f-14 black-14 w-600">Pending</span>}
                                                        value={jobData.status.PENDING}
                                                        valueStyle={{ color: '#1890ff', fontSize: '14px', fontFamily: 'Manrope' }}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <Statistic
                                                        title={<span className="manrope f-14 black-14 w-600">Successful</span>}
                                                        value={jobData.status.SUCCESS}
                                                        valueStyle={{ color: '#52c41a', fontSize: '14px', fontFamily: 'Manrope' }}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <Statistic
                                                        title={<span className="manrope f-14 black-14 w-600">Failed</span>}
                                                        value={jobData.status.FAILED}
                                                        valueStyle={{ color: '#ff4d4f', fontSize: '14px', fontFamily: 'Manrope' }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                }
                            >
                                <Card>
                                    <Table
                                        columns={columns}
                                        dataSource={jobData.items}
                                        rowClassName={(record, index) => {
                                            return index % 2 === 0 ? 'even-row' : 'odd-row';
                                        }}
                                        rowKey="id"
                                        scroll={{ x: 1200 }}
                                    />
                                </Card>
                            </Panel>
                        ))}
                    </Collapse>
                )}
            </div>

            {/* Bulk Upload Modal */}
            <Modal
                title="Bulk Upload Products to Shopify"
                visible={bulkModalVisible}
                onCancel={() => setBulkModalVisible(false)}
                footer={null}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                    <div>
                        <input
                            type="file"
                            accept=".csv"
                            onChange={e => setBulkFile(e.target.files[0])}
                            style={{ marginTop: 8 }}
                            disabled={bulkUploading}
                        />
                        <div style={{ marginTop: 8, fontSize: '13px', color: '#888' }}>
                            Tip: Download <a
                                href="#"
                                style={{ color: '#1890ff', textDecoration: 'underline', fontSize: '13px', cursor: 'pointer', marginLeft: 2, marginRight: 2 }}
                                onClick={e => {
                                    e.preventDefault();
                                    const csvContent = 'title,handle,product_id\nSample Product,handle-1,12345';
                                    const blob = new Blob([csvContent], { type: 'text/csv' });
                                    const url = URL.createObjectURL(blob);
                                    const a = document.createElement('a');
                                    a.href = url;
                                    a.download = 'shopify_bulk_sample.csv';
                                    document.body.appendChild(a);
                                    a.click();
                                    document.body.removeChild(a);
                                    URL.revokeObjectURL(url);
                                }}
                            >sample csv</a> to see the required format.
                        </div>
                    </div>
                    <Button
                        type="primary"
                        style={{ marginTop: 16, width: "100%" }}
                        disabled={bulkUploading || !bulkFile}
                        onClick={async () => {
                            if (!bulkFile) return;
                            setBulkUploading(true);
                            try {
                                // Read CSV file as string
                                const reader = new FileReader();
                                reader.onload = async (e) => {
                                    const csvString = e.target.result;
                                    const payload = {
                                        csv_data: csvString,
                                        username: CUSTOMER_USERNAME,
                                    };
                                    const res = await fetch(ENVIRONMENT.SHOPIFY_BULK_UPLOAD_MODEL_V2, {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify(payload),
                                    });
                                    if (res.ok) {
                                        message.success('Bulk upload request sent successfully!');
                                        setBulkModalVisible(false);
                                        setBulkFile(null);
                                        window.location.reload();
                                    } else {
                                        const data = await res.json().catch(() => ({}));
                                        message.error(data.message || 'Error uploading bulk CSV.');
                                    }
                                    setBulkUploading(false);
                                };
                                reader.onerror = () => {
                                    message.error('Error reading CSV file.');
                                    setBulkUploading(false);
                                };
                                reader.readAsText(bulkFile);
                            } catch (err) {
                                message.error('Error uploading bulk CSV.');
                                setBulkUploading(false);
                            }
                        }}
                    >
                        {bulkUploading ? <Spin size="small" /> : "Upload"}
                    </Button>
                </div>
            </Modal>

        </CustomerMainLayout>
    );
};

export default ShopifyJobStatus;
